import { ChevronUp, Truck, RefreshCw, ShieldAlert, Wallet, PackageCheck, Repeat, Phone } from 'lucide-react';

const ReturnPolicyPage = () => {
    const sections = [
        {
          icon: <Truck className="w-6 h-6" />,
          title: "1. Políticas de Envío y Entrega",
          content: (
            <>
              <p className="mb-4">Nuestra Política de Envío y Entrega forma parte integral de nuestros Términos y Condiciones. Al realizar una compra, aceptas estas disposiciones.</p>
              <p className="mb-4">
                Nos complace proporcionar servicios de Envío y Entrega eficientes y asequibles en todo el país. Para garantizar que tu experiencia de compra en nuestra tienda en línea sea satisfactoria, te recomendamos revisar la información a continuación:
              </p>
              <h3 className="font-poppins font-semibold text-primary mb-2">Responsabilidades del Cliente:</h3>
              <ul className="list-decimal pl-6 space-y-2">
                <li>Proporcionar dirección exacta y verificada</li>
                <li>Incluir información adicional relevante para la entrega</li>
                <li>Asegurar disponibilidad para recepción</li>
                <li>Presentar documento de identidad al recibir</li>
                <li>Revisar contenido y condiciones del paquete</li>
              </ul>
              <p className="mt-4 text-sm text-primary-dark">
                *El uso adecuado de abreviaturas, números de calles, edificios o apartamentos, así como información de ruta, es esencial para asegurar una entrega puntual.
              </p>
            </>
          ),
        },
        {
          icon: <PackageCheck className="w-6 h-6" />,
          title: "2. Proceso de Envío",
          content: (
            <>
              <p className="mb-4">
                La gestión de envíos de SAHEZ MEDIC E.I.R.L se caracteriza por su simplicidad y rapidez. Las empresas de transporte asignan los paquetes a los colores disponibles, permitiendo al cliente coordinar la recogida de su pedido.
              </p>
              <h3 className="font-poppins font-semibold text-primary mb-2">Opciones de envío:</h3>
              <ul className="list-disc pl-6 space-y-2">
                <li>
                  <strong>Envío Rápido:</strong>
                  <p>1-3 horas (misma ciudad)</p>
                </li>
                <li>
                  <strong>Envío Estándar:</strong>
                  <p>2-3 días hábiles (nacional)</p>
                </li>
              </ul>
              <h3 className="font-poppins font-semibold text-primary mb-2">Costos:</h3>
              <ul className="list-disc pl-6 space-y-2">
                <li>Varían según opción seleccionada</li>
                <li>Mostrados al finalizar compra</li>
                <li>No reembolsables excepto defectos</li>
              </ul>
              <p className="mt-4 text-sm text-primary-dark">
                *Rechazar paquete implica asumir costos de envío originales
              </p>
            </>
          ),
        },
        {
          icon: <ShieldAlert className="w-6 h-6" />,
          title: "3. Condiciones para la Devolución",
          content: (
            <>
              <ul className="list-disc pl-6 space-y-2">
                <li>Producto en estado original con empaque y etiquetas</li>
                <li>Sin signos de uso, rayones o daños</li>
                <li>Notificación dentro de 5 días posteriores a recepción</li>
                <li>Productos en oferta sujetos a condiciones especiales</li>
              </ul>
              <div className="mt-4 bg-accent/10 p-4 rounded-lg">
                <p className="text-sm font-semibold">Importante: Pasados 5 días no se aceptan devoluciones</p>
              </div>
            </>
          ),
        },
        {
          icon: <RefreshCw className="w-6 h-6" />,
          title: "4. Proceso de Devolución",
          content: (
            <>
              <ol className="list-decimal pl-6 space-y-4">
                <li>
                  <strong>Notificación:</strong>
                  <p>Contactar vía:
                    <a href="mailto:info@sahezmedic.com" className="text-primary block mt-1">info@sahezmedic.com</a>
                    <a href="https://wa.me/18295669132" className="text-primary block">WhatsApp: 829-566-9132</a>
                  </p>
                </li>
                <li>
                  <strong>Instrucciones:</strong>
                  <p>Recibirás dirección y protocolo de envío</p>
                </li>
                <li>
                  <strong>Envío:</strong>
                  <p>Empacar cuidadosamente (gastos asumidos por cliente)</p>
                </li>
              </ol>
            </>
          ),
        },
        {
          icon: <Wallet className="w-6 h-6" />,
          title: "5. Reembolsos",
          content: (
            <>
              <ul className="list-disc pl-6 space-y-2">
                <li>Procesamiento en 5-7 días hábiles post-verificación</li>
                <li>Mismo método de pago original</li>
                <li>Excepciones requieren acuerdo previo</li>
              </ul>
              <div className="mt-4 p-4 bg-primary/10 rounded-lg">
                <p className="text-sm">Tiempo de acreditación depende de la entidad financiera</p>
              </div>
            </>
          ),
        },
        {
          icon: <ShieldAlert className="w-6 h-6" />,
          title: "6. Artículos Defectuosos",
          content: (
            <>
              <ul className="list-disc pl-6 space-y-2">
                <li>Notificar dentro de 3 días posteriores a entrega</li>
                <li>Reemplazo o reembolso completo</li>
                <li>Sin costo adicional</li>
              </ul>
              <div className="mt-4 bg-red-100 p-4 rounded-lg">
                <p className="text-red-600 text-sm">Pasados 3 días pierdes derecho a reclamación</p>
              </div>
            </>
          ),
        },
        {
          icon: <Repeat className="w-6 h-6" />,
          title: "7. Cambios",
          content: (
            <>
              <ul className="list-disc pl-6 space-y-2">
                <li>Para tallas/colores: realizar nueva compra</li>
                <li>Seguir proceso de devolución para artículo original</li>
                <li>Productos personalizados no aplican</li>
              </ul>
              <p className="mt-4 text-primary-dark text-sm">
                *Consultar disponibilidad para cambios directos
              </p>
            </>
          ),
        },
      ];
      

  const containerVariants = {
    hidden: { opacity: 0 },
    visible: {
      opacity: 1,
      transition: {
        staggerChildren: 0.1,
        delayChildren: 0.2
      }
    }
  };

  const itemVariants = {
    hidden: { y: 20, opacity: 0 },
    visible: { y: 0, opacity: 1 }
  };

  return (
    <div className="min-h-screen bg-main-bg">
      {/* Encabezado */}
      <header className="bg-gradient-to-r from-primary to-dark text-main-bg py-20 px-4">
        <div className="max-w-7xl mx-auto text-center">
          <h1 
            className="text-4xl md:text-5xl font-poppins font-bold mb-4"
          >
            Políticas de Envío y Devoluciones
          </h1>
          <p className="text-lg font-montserrat max-w-3xl mx-auto">
            Garantizando transparencia y satisfacción en cada transacción
          </p>
        </div>
      </header>

      {/* Contenido principal */}
      <main className="max-w-7xl mx-auto px-4 py-16">
        <div className="grid lg:grid-cols-4 gap-12">
          {/* Índice lateral */}
          <div 
            className="hidden lg:block lg:col-span-1 sticky top-20 h-fit"
          >
            <div className="bg-section-bg p-6 rounded-xl shadow-lg">
              <h2 className="text-xl font-poppins font-semibold text-dark mb-4">Índice</h2>
              <ul className="space-y-3 font-montserrat">
                {sections.map((section, index) => (
                  <li key={index}>
                    <a 
                      href={`#section-${index + 1}`} 
                      className="text-dark hover:text-primary transition-colors flex items-center gap-2"
                    >
                      <ChevronUp className="w-4 h-4 rotate-45" />
                      {section.title.split(' ').slice(1).join(' ')}
                    </a>
                  </li>
                ))}
              </ul>
            </div>
          </div>

          {/* Secciones */}
          <div 
            className="lg:col-span-3 space-y-12"
           
          >
            {sections.map((section, index) => (
              <section 
                key={index}
                id={`section-${index + 1}`}
                className="bg-section-bg p-8 rounded-xl shadow-md hover:shadow-lg transition-shadow"
              >
                <div className="flex items-center gap-4 mb-6">
                  <div className="bg-primary p-3 rounded-lg text-main-bg">
                    {section.icon}
                  </div>
                  <h2 className="text-2xl font-poppins font-semibold text-dark">
                    {section.title}
                  </h2>
                </div>
                <div className="text-gray-700 font-montserrat leading-relaxed">
                  {section.content}
                </div>
              </section>
            ))}
          </div>
        </div>

        {/* Sección de contacto */}
        <div 
          className="mt-16 p-8 border-2 border-primary rounded-xl bg-main-bg"
         
        >
          <div className="max-w-4xl mx-auto text-center">
            <Phone className="w-12 h-12 text-primary mx-auto mb-4" />
            <h3 className="text-2xl font-poppins font-semibold text-dark mb-4">
              ¿Necesitas ayuda con tu devolución?
            </h3>
            <p className="font-montserrat text-gray-600 mb-6">
              Nuestro equipo de atención al cliente está disponible para asistirte
            </p>
            <div className="flex flex-col md:flex-row gap-4 justify-center">
              <a
                href="mailto:info@sahezmedic.com"
                className="bg-primary text-main-bg px-6 py-2 rounded-lg font-poppins hover:bg-dark transition-colors"
              >
                Contactar por Email
              </a>
              <a
                href="https://wa.me/18295669132"
                className="bg-dark text-main-bg px-6 py-2 rounded-lg font-poppins hover:bg-primary transition-colors"
              >
                WhatsApp Directo
              </a>
            </div>
          </div>
        </div>

        {/* Botón flotante */}
        <button type='button' title='back to top'
          onClick={() => window.scrollTo({ top: 0, behavior: 'smooth' })}
          className="fixed bottom-8 right-8 bg-dark text-main-bg p-3 rounded-full shadow-xl hover:bg-primary transition-colors"
        
        >
          <ChevronUp className="w-6 h-6" />
        </button>
      </main>
    </div>
  );
};

export default ReturnPolicyPage;